module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Book-Of-Love-The.2a5304f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Book-Of-Love-The.jpg
// module id = 6jgA
// module chunks = 0